import { Button, ButtonProps, Col, Divider, Form, Input, Popover, Row, Select, Tooltip, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IState } from '../../../redux/store';
import httpRequest from '../../../utils/HttpRequest';
import { urls } from '../../../config/url';
import { updateParam } from '../../../redux/progress/param/paramAction'
import { IModuleParam } from '../../../redux/progress/module/moduleInterface';
import { IFileInfo } from './fileinfo.interfact';
export interface LocalButtonPropies extends ButtonProps {
    children?: React.ReactNode;
    param: IModuleParam;
    onFileChanged?: (fileInfo: IFileInfo) => void;
    fileValue?: IFileInfo;
}
function ModelTable(props: {
    surveyedit: (param: any) => void,
    disableTable: boolean,
    lineName: string,
    userName: string,
    activeProject: string,
    modules: any,
    // testName: any
    tableClick: (param: any) => void,
}) {
    const [loading, setLoading] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const [inputDisable, setInputDisable] = useState<boolean>(false) // 表格点击确定

    const [tableData, setTableData] = useState<any>([
        { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
        { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
        { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
        { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
        { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' }])

    // table 确定
    const tableClick = () => {

        const checkarr = [] //查重复
        const devno = [] //设备号查重复
        const cancalTable = []
        const cor = []
        if (tableData === null) {
            return
        }
        for (let index = 0; index < tableData.length; index++) {
            const element = tableData[index];
            if (element.EUINO != '' && element.EUINO != undefined) {
                cancalTable.push(element)
                devno.push(element.EUINO)
                checkarr.push(Number(element.LINE) * 1000 + Number(element.POINT))
                cor.push(JSON.stringify({ x: element.XCOR, y: element.YCOR }))
                let isIntegerx = isInteger(element.XCOR)
                let isIntegery = isInteger(element.YCOR)
                let isIntegerPoint = isInteger(element.POINT)
                let isIntegerLine = isInteger(element.LINE)
                let num = index + 1
                if (isIntegerx === false) {
                  
                    message.error('第'+num + '条' +'x坐标需为整形')
                    return
                }
                if (isIntegery === false) {
                    message.error('第'+num + '条' +'y坐标需为整形')
                    return
                }
                if (isIntegerPoint === false) {
                    message.error('第'+num + '条' +'点号需为整形')
                    return
                }
                if (isIntegerLine === false) {
                    message.error('第'+num + '条' +'线号需为整形')
                    return
                }
            }
        }
        let setarr = new Set(cor).size != cor.length
        if (setarr) {
            message.error('观测系统数据x、y坐标有重复')
            return
        }

        for (var i = 0; i < checkarr.length; i++) {
            if (checkarr.indexOf(checkarr[i]) != i) {
                message.error("数据有重复元素：线号" + cancalTable[i].LINE + ',点号' + cancalTable[i].POINT)
                return
            }
        }
        for (var i = 0; i < devno.length; i++) {
            if (devno.indexOf(devno[i]) != i) {
                message.error("设备号有重复：" + devno[i])
                return
            }
        }
        setTableData(cancalTable)
        setInputDisable(true)
        if (props.surveyedit) {
            props.surveyedit(cancalTable)
        }
        if (props.tableClick) {
            props.tableClick(true)
        }
    }

    const content = (
        <div>
            <p>CSV文件格式，必须包含六列信息，列名字顺序固定，都是大写英文字母。 </p>
            <p>具体信息是：LINE(线号),POINT(点号),EUINO(设备号),XCOR(X坐标),YCOR(Y坐标),ELEV(高程)。 </p>
        </div>
    );
    const isInteger = (obj: number) => {
        return obj%1 === 0
       }

    useEffect(() => {
        if (props.lineName === '') {
            return
        }
        httpRequest(urls.surveydata, {
            USER_NAME: props.userName,
            PROJECTNAME: props.activeProject,
            proj_name: props.lineName,
            PRO_MODULE_NAME: props.modules[0].PRO_MODULE_NAME
        }).then(res => {
            let arr = []
            for (let index = 1; index < res.data.data.length; index++) {
                const element = res.data.data[index].split(',');
                arr.push({ LINE: element[4], POINT: element[5], EUINO: element[6], XCOR: element[7], YCOR: element[8], ELEV: element[9] })
            }
            setTableData(arr)
        }).catch(err => {

        })
    }, [props.lineName])

    useEffect(() => {
        
        setInputDisable(props.disableTable)
    }, [props.disableTable])
    return <>
        <div >
            <table >
                <tr>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>序号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>线号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>点号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>设备号</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>X坐标</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>Y坐标</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>高程</td>
                    <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>操作</td>

                </tr>
                {
                    tableData && tableData.map((item: { LINE: string | number; POINT: string | number; EUINO: string | number, XCOR: string | number, YCOR: string | number, ELEV: string | number }, i: number) => {

                        return (
                            <tr >
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>{i + 1}</td>

                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.LINE} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].LINE = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.POINT} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].POINT = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.EUINO} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].EUINO = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.XCOR} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].XCOR = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.YCOR} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].YCOR = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <Input bordered={false} style={{ width: 100, }} disabled={inputDisable || props.disableTable} value={item.ELEV} onChange={(e) => {
                                        let arr = tableData
                                        arr[i].ELEV = e.target.value
                                        setTableData([...arr])
                                    }} />
                                </td>
                                <td style={{ border: '1px solid #ccc', padding: '5px 25px', height: 26 }}>
                                    <div style={{ display: 'inline-block', width: 25, height: 25, borderRadius: '50%', border: '1px solid #ccc', cursor: 'pointer', textAlign: 'center', verticalAlign: 'middle', }} onClick={() => {
                                        if (inputDisable || props.disableTable) {
                                            message.warning('请先点击重置，再新增数据')
                                            return
                                        }
                                        let arr = tableData
                                        arr.splice(i + 1, 0, { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' });

                                        setTableData([...arr])


                                    }}>+ </div>
                                    <div style={{ display: 'inline-block', width: 25, height: 25, borderRadius: '50%', border: '1px solid #ccc', cursor: 'pointer', textAlign: 'center', verticalAlign: 'middle', marginLeft: 20 }} onClick={() => {
                                        if (inputDisable || props.disableTable) {
                                            message.warning('请先点击重置，再删除数据')
                                            return
                                        }
                                        let arr = tableData
                                        
                                        if (arr.length === 1) {
                                            message.warning('数据至少有一条')
                                            return 
                                        }
                                        arr.splice(i, 1)
                                        setTableData([...arr])

                                    }} >
                                        -
                                    </div>

                                </td>
                            </tr>
                        )
                    })
                }
                <tr>
                    <td colSpan={8} style={{ border: '1px solid #ccc', height: 26, padding: 10 }}>
                        <Button style={{ float: 'right' }} type='primary' size='large' onClick={tableClick} disabled={inputDisable} >确认</Button>
                        <Button size='large' style={{ float: 'right', marginRight: 10 }} type='primary' disabled={!inputDisable} onClick={() => {

                            let arr = [
                                { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
                                { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
                                { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
                                { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' },
                                { LINE: '', POINT: '', EUINO: '', XCOR: '', YCOR: '', ELEV: '' }]
                            setTableData(arr)
                            setInputDisable(false)
                        }}>重置</Button>

                        <Button style={{ float: 'right', marginRight: 10 }}  disabled={!inputDisable} type='primary' size='large' onClick={() => {
                            let obj = ["LINE", "POINT", "EUINO", "XCOR", "YCOR", "ELEV"]
                            let header = obj.join(',') + '\n';
                            let datas = tableData.map((ele: any) => {
                                return `${ele.LINE},${ele.POINT},${ele.EUINO},${ele.XCOR},${ele.YCOR},${ele.ELEV}\n`;
                            });
                            let dataStrs = [header, ...datas].join('');
                            // 创建一个 Blob 对象
                            const blob = new Blob(['\uFEFF' + dataStrs], {
                                type: 'text/plain;charset=utf-8',
                            });
                            // 创建一个 a 标签
                            const link = document.createElement("a");
                            // 一个 URL，可以是任意协议的，不只是 HTTP 协议
                            // 这里创建了一个 Blob URL
                            // blob:http://localhost:1234/9b3be48e-9948-496d-8a2b-18d437eb46e0
                            link.href = URL.createObjectURL(blob);

                            // 此属性表示用户下载文件而不是进行导航到 URL，这里指的为文件名
                            link.download = "观测系统数据.csv";
                            link.click();
                            // 需要释放 URL
                            URL.revokeObjectURL(link.href);

                        }}>导出</Button>
                        <Popover content={content} title='观测系统文件格式要求'>
                            <Button style={{ float: 'right', marginRight: 10 }}disabled={inputDisable} type='primary' size='large' onClick={() => {
                                inputRef.current?.click();
                            }}>观测系统数据导入</Button>
                        </Popover>

                        <input
                            type="file"
                            style={{ visibility: 'hidden', width: 0, height: 0, border: 0 }}
                            ref={inputRef}
                            onChange={(e) => {

                                const file = e.target.files ? e.target.files[0] : null;
                                if (file) {
                                    setLoading(true);
                                    const reader = new FileReader();
                                    reader.onload = (e) => {
                                        const some = reader.result;
                                        if (some === null) {
                                            return
                                        }
                                        setLoading(false);

                                        let code = (some as string).split(/[(\r\n)\r\n]+/);
                                        let keyArr = code[0].split(',')
                                        let type = keyArr[0] === 'LINE' && keyArr[1] === 'POINT' && keyArr[2] === 'EUINO' && keyArr[3] === 'XCOR' && keyArr[4] === 'YCOR' && keyArr[5] === 'ELEV'
                                        if (type === false) {
                                            message.error('观测系统导入文件格式错误，请查看')
                                            return
                                        } else {
                                            let arr: any = []
                                            for (let index = 1; index < code.length; index++) {
                                                const element = code[index].split(',');
                                                if (element.length != 1) {
                                                    arr.push({ LINE: element[0], POINT: element[1], EUINO: element[2], XCOR: element[3], YCOR: element[4], ELEV: element[5] })
                                                }
                                            }
                                            setTableData(arr)
                                            if (props.surveyedit) {
                                                props.surveyedit(arr)
                                            }
                                        }

                                    };

                                    reader.readAsText(file);
                                    e.target.value = '';
                                }
                            }}
                        />
                    </td>
                </tr>

            </table>

        </div >

    </>
}

const mapStateToProps = (state: IState) => {
    const userName = state.user.userName;
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
        userName,
        activeName: state.project.activeName,
        lineName: state.progress.line.activeName,
        activeProject: state.project.activeName,
        modules:modules
        // PRO_MODULE_NAME: state.progress.modules.modules[0].PRO_MODULE_NAME,
        // testName: state.progress.params.proj_name
    };
};

export default connect(
    mapStateToProps,
    { updateParam }
)(ModelTable);
